import { useState, useEffect} from 'react'
import {useParams, useNavigate, Link} from "react-router-dom"
import axios from 'axios'
import moment from 'moment'
import RaceBlock from '../components/RaceBlock'
import {useLang} from '../components/LangProvider'
import {auth, useAuth} from '../components/AuthProvider'
import typeOf from "validator/es/lib/util/typeOf";


function Event(){
  // init with event = null -> show 'loading'
  // if response 200 -> build page banner and ask for races
  // if error: event = undefined -> show 'not found'

  const event_id = useParams().id
  const {lang, t} = useLang()
  const [event, setEvent] = useState(null)
  // const navigate = useNavigate()
  const {auth} = useAuth()

  let headers = {accept: "application/json"}
  if (auth.isAuth) headers['authorization'] ='Bearer ' + auth.token

  let page = <section className='event loading'>
    <span>loading ...</span>
  </section>

  useEffect(() => {
    axios
    .get(process.env.REACT_APP_BACKEND_EVENT,{
      params:{
        id : event_id,
        showRaces : 1,
      },
      headers
    })
    .then(
      res=>{
        console.log('res of event: ',res)
        setEvent(res.data)
      }
      
    )
    .catch((res) => {
      /**send to 404 ? */
      console.log('Event request error:',res.message)
      setEvent(undefined)
    //  navigate("/",true)
    })
  },[])

  // undefined only after axios get non-200 response
  if (typeOf(event) === "undefined"){
    page = <section className="event">
      <h3 className="event-error__no-event">{lang['event no such event found']}</h3>
      <Link to={'/'}>{lang['event go home']}</Link>
    </section>
  }

  // if 'event' have something
  if (event){
    page = <section className="event" style={{'--bg-desktop': `url(${event.background})`,'--bg-mobile': `url(${event.background_mobile})`}}>
      <div className="event-title">
        <div className="event-title__left">
          <h1 className="left-border">{t(event.name)}</h1>
          <div className="event__description" dangerouslySetInnerHTML={{__html: t(event.description)}}>
          </div>
        </div>

        <div className="event-title__right">
          <h1 className="left-border">{lang["event date"]}<span>{moment(event.date_start_at).format("DD/MM/YYYY") }</span></h1>
          <h1 className="left-border">{lang["event start"]}<span>{moment(event.date_start_at).format("HH:MM")}</span></h1>
          <h1 className="left-border">{lang["event address"]}<span>{t(event.address)}</span></h1>
        </div>

      </div>
      {/* if no races in this event - put some placeholder */}
      {event.races.length === 0 ? <h3 className="event-error__no-races">{lang['event no races here yet']}</h3> : <RaceBlock event={event} />}

    </section>
  }

  return page
}

export default Event